// frontend/src/modules/folha/pages/ConfiguracaoRH.js
import React, { useState, useEffect } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';

// ✅ API_URL DECLARADO NO TOPO
const API_URL = process.env.REACT_APP_API_URL || '';

function ConfiguracaoRH({ usuario }) {
  const empresaId = usuario?.empresa_id || 1;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [config, setConfig] = useState({
    adiantamento_percentual_max: 50,
    adiantamento_permitir_lote: true,
    adiantamento_dias_antecedencia: 10,
    folha_dia_pagamento: 5,
    folha_calcular_inss: true,
    folha_calcular_irrf: true,
    folha_calcular_fgts: true,
    inss_aliquota_1: 7.5,
    inss_teto_1: 1412.00,
    inss_aliquota_2: 9,
    inss_teto_2: 2666.68,
    inss_aliquota_3: 12,
    inss_teto_3: 4000.03,
    inss_aliquota_4: 14,
    inss_teto_4: 7786.02,
    irrf_isento: 1903.98,
    irrf_aliquota_1: 7.5,
    irrf_deducao_1: 142.80,
    irrf_aliquota_2: 15,
    irrf_deducao_2: 354.80,
    irrf_aliquota_3: 22.5,
    irrf_deducao_3: 636.13,
    irrf_aliquota_4: 27.5,
    irrf_deducao_4: 869.36
  });

  const token = localStorage.getItem('token');

  // ============================================
  // BUSCAR CONFIGURAÇÕES - ✅ URL CORRETA
  // ============================================
  const fetchConfig = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/folha/config/rh/${empresaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar configurações');
      const data = await response.json();
      setConfig(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfig({
      ...config,
      [name]: type === 'checkbox' ? checked : parseFloat(value) || value
    });
  };

  // ============================================
  // SALVAR CONFIGURAÇÕES - ✅ URL CORRETA
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${API_URL}/api/folha/config/rh/${empresaId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(config)
      });

      if (!response.ok) throw new Error('Erro ao salvar configurações');

      setSuccess('✅ Configurações salvas com sucesso!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h2>⚙️ Configurações de RH</h2>
      <p style={{ color: '#6c757d' }}>Configure as regras de adiantamento e folha de pagamento.</p>

      {error && <div style={{ backgroundColor: '#ffebee', padding: '10px', borderRadius: '4px', color: '#c62828', marginBottom: '15px' }}>❌ {error}</div>}
      {success && <div style={{ backgroundColor: '#e8f5e9', padding: '10px', borderRadius: '4px', color: '#2e7d32', marginBottom: '15px' }}>✅ {success}</div>}

      <form onSubmit={handleSubmit} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <h3>💰 Adiantamento Salarial</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
          <div>
            <label>Percentual Máximo (%)</label>
            <input 
              type="number" 
              name="adiantamento_percentual_max"
              value={config.adiantamento_percentual_max}
              onChange={handleChange}
              step="0.01"
              style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <small style={{ color: '#6c757d' }}>Percentual máximo do salário para adiantamento (Lei: até 50%)</small>
          </div>
          <div>
            <label>Dias de Antecedência</label>
            <input 
              type="number" 
              name="adiantamento_dias_antecedencia"
              value={config.adiantamento_dias_antecedencia}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <small style={{ color: '#6c757d' }}>Dias antes do pagamento para solicitar adiantamento</small>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label>Permitir Adiantamento em Lote</label>
            <input 
              type="checkbox" 
              name="adiantamento_permitir_lote"
              checked={config.adiantamento_permitir_lote}
              onChange={handleChange}
              style={{ width: '20px', height: '20px' }}
            />
          </div>
          <div>
            <label>Dia do Pagamento da Folha</label>
            <input 
              type="number" 
              name="folha_dia_pagamento"
              value={config.folha_dia_pagamento}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <small style={{ color: '#6c757d' }}>Dia do mês para pagamento da folha</small>
          </div>
        </div>

        <h3 style={{ marginTop: '20px' }}>📊 Cálculos da Folha</h3>
        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label>Calcular INSS</label>
            <input 
              type="checkbox" 
              name="folha_calcular_inss"
              checked={config.folha_calcular_inss}
              onChange={handleChange}
              style={{ width: '20px', height: '20px' }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label>Calcular IRRF</label>
            <input 
              type="checkbox" 
              name="folha_calcular_irrf"
              checked={config.folha_calcular_irrf}
              onChange={handleChange}
              style={{ width: '20px', height: '20px' }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label>Calcular FGTS</label>
            <input 
              type="checkbox" 
              name="folha_calcular_fgts"
              checked={config.folha_calcular_fgts}
              onChange={handleChange}
              style={{ width: '20px', height: '20px' }}
            />
          </div>
        </div>

        <h3 style={{ marginTop: '20px' }}>📋 Tabela INSS</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px' }}>
          <div>
            <label>Faixa 1 (%)</label>
            <input type="number" name="inss_aliquota_1" value={config.inss_aliquota_1} onChange={handleChange} step="0.01" style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ fontSize: '12px', color: '#6c757d' }}>Teto: R$ {config.inss_teto_1}</div>
          </div>
          <div>
            <label>Faixa 2 (%)</label>
            <input type="number" name="inss_aliquota_2" value={config.inss_aliquota_2} onChange={handleChange} step="0.01" style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ fontSize: '12px', color: '#6c757d' }}>Teto: R$ {config.inss_teto_2}</div>
          </div>
          <div>
            <label>Faixa 3 (%)</label>
            <input type="number" name="inss_aliquota_3" value={config.inss_aliquota_3} onChange={handleChange} step="0.01" style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ fontSize: '12px', color: '#6c757d' }}>Teto: R$ {config.inss_teto_3}</div>
          </div>
          <div>
            <label>Faixa 4 (%)</label>
            <input type="number" name="inss_aliquota_4" value={config.inss_aliquota_4} onChange={handleChange} step="0.01" style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ fontSize: '12px', color: '#6c757d' }}>Teto: R$ {config.inss_teto_4}</div>
          </div>
        </div>

        <h3 style={{ marginTop: '20px' }}>📋 Tabela IRRF</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          <div>
            <label>Isento até (R$)</label>
            <input type="number" name="irrf_isento" value={config.irrf_isento} onChange={handleChange} step="0.01" style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
          </div>
          <div>
            <label>Alíquota 1 (%) - Dedução (R$)</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input type="number" name="irrf_aliquota_1" value={config.irrf_aliquota_1} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
              <input type="number" name="irrf_deducao_1" value={config.irrf_deducao_1} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            </div>
          </div>
          <div>
            <label>Alíquota 2 (%) - Dedução (R$)</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input type="number" name="irrf_aliquota_2" value={config.irrf_aliquota_2} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
              <input type="number" name="irrf_deducao_2" value={config.irrf_deducao_2} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            </div>
          </div>
          <div>
            <label>Alíquota 3 (%) - Dedução (R$)</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input type="number" name="irrf_aliquota_3" value={config.irrf_aliquota_3} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
              <input type="number" name="irrf_deducao_3" value={config.irrf_deducao_3} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            </div>
          </div>
          <div>
            <label>Alíquota 4 (%) - Dedução (R$)</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input type="number" name="irrf_aliquota_4" value={config.irrf_aliquota_4} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
              <input type="number" name="irrf_deducao_4" value={config.irrf_deducao_4} onChange={handleChange} step="0.01" style={{ width: '50%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }} />
            </div>
          </div>
        </div>

        <button type="submit" disabled={loading} style={{ marginTop: '20px', padding: '10px 30px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          <FaSave /> {loading ? 'Salvando...' : 'Salvar Configurações'}
        </button>
        <button type="button" onClick={() => window.history.back()} style={{ marginTop: '20px', marginLeft: '10px', padding: '10px 30px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          <FaTimes /> Cancelar
        </button>
      </form>
    </div>
  );
}

export default ConfiguracaoRH;